<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">New Buy Package</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <span class="preview-title-lg overline-title">Package Information</span>
                                    <div class="row gy-4">                                        
                                        <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                            <div class="row gy-4">
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label">User</label>
                                                        <div class="form-control-wrap">
                                                            <userdropdown v-model="buyPackagePrice.userId" :values="buyPackagePrice.userId" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Package Plan</label>
                                                        <div class="form-control-wrap">
                                                            <package-plan-dropdown @input="getPackagePlan" :values="buyPackagePrice.packagePriceId" />
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Bank</label>
                                                        <div class="form-control-wrap">
                                                            <bankdropdown v-model="buyPackagePrice.bankId" :values="buyPackagePrice.bankId" />
                                                        </div>
                                                    </div>
                                                </div>



                                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div class="form-group">
                                                        <label class="form-label">Description</label>
                                                        <div class="form-control-wrap">
                                                            <textarea v-model="buyPackagePrice.description" class="form-control no-resize"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">ScreenShot Attach</label>
                                                <div class="form-control-wrap">
                                                    <uploadimage v-on:picPath="getImage" v-bind:path="buyPackagePrice.screenShotImage" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <!--<button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser('Draft')" class="btn btn-primary" style="margin-right: 10px;"> Save As Draft</button>-->
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser('Processing')" class="btn btn-primary" style="margin-right: 10px;"> Save As Processing</button>
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser('Approved')" class="btn btn-primary" style="margin-right: 10px;"> Save As Approved</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default ({
        components: {
            Loading
        },
        name: 'newPackagePrice',
        data: function () {
            return {
                loading: false,
                buyPackagePrice: {
                    id: '00000000-0000-0000-0000-000000000000',
                    packagePlanName: '',
                    packagePlanAmount: '',
                    packagePriceId: '',
                    screenShotImage: '',                    
                    description: '',
                    bankId: '',
                    userId: '',
                    approval: '',
                }
            }
        },
        validations: {
            buyPackagePrice:
            {
                packagePlanAmount:
                {
                    required
                },
                packagePriceId:
                {
                    required
                },
                bankId:
                {
                    required
                }
            }
        },

        methods: {
            getPackagePlan: function (data) {
                this.buyPackagePrice.packagePlanName = data.name;
                this.buyPackagePrice.packagePlanAmount = data.amount;
                this.buyPackagePrice.packagePriceId = data.id;
            },
            
            getImage: function (path) {
                this.buyPackagePrice.screenShotImage = path;
            },

            GoToList: function () {
                this.$router.push('/BuyPackages')
            },

            SaveNewUser: function (approval) {
                var root = this;
                this.loading = true;
                
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.buyPackagePrice.approval = approval;

                root.$https.post('/PackagePlan/SaveBuyPackage', this.buyPackagePrice, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Created!',
                                text: 'Data has been Saved successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

        },
        created: function () {
            //if (this.$route.query.data != undefined) {
            //    this.newPackagePrice = this.$route.query.data;
            //}
        },
    })
</script>
